import type { BotVertical } from '../../types/leadBot.js';
import { assertNeverVertical } from './verticals.js';

// BOT SETUP LAYOUT BY VERTICAL (KyckConnect redesign, Phase 1 D). PURE. Layout and visibility only: nothing here changes how a
// bot behaves, and every section keeps saving exactly what it saved before.

/** The account industries that imply a vertical. Anything else (or none) implies nothing: the person chooses. */
export function defaultVerticalForIndustry(industry: string | null | undefined): BotVertical | null {
  switch (industry) {
    case 'fitness_franchise':
      return 'fitness';
    case 'automotive_franchise':
      return 'automotive';
    default:
      return null;
  }
}

export interface SetupSections {
  /** The automotive knowledge base (account level). */
  knowledgeBase: boolean;
  /** The vehicle stock upload. */
  vehicleStock: boolean;
  /** The fitness card: sign-off, disclosure, instructions, capabilities, follow-ups. */
  fitnessCard: boolean;
  /** A link to the business profile, the fitness bot's only fact source. */
  businessProfileLink: boolean;
}

export function setupSections(vertical: BotVertical): SetupSections {
  switch (vertical) {
    case 'automotive':
      return { knowledgeBase: true, vehicleStock: true, fitnessCard: false, businessProfileLink: false };
    case 'fitness':
      return { knowledgeBase: false, vehicleStock: false, fitnessCard: true, businessProfileLink: true };
    default:
      return assertNeverVertical(vertical);
  }
}
